/* eslint-disable import/prefer-default-export */
import CryptoJS from 'crypto-js';
import { isNull } from 'lodash';

export class CryptoUtil {
  static decrypt = (text: string) => {
    const bytes = CryptoJS.AES.decrypt(text, 'my-secret-key@123');
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  };

  static encrypt = (text: string) => {
    return CryptoJS.AES.encrypt(
      JSON.stringify(text),
      'my-secret-key@123',
    ).toString();
  };

  static decryptAes = (text: string) => {
    if (isNull(text)) return null;
    const parsedKey = CryptoJS.enc.Base64.parse('c2RhOGVmNTRwc3JnaHR5MA==');
    const decryptedData = CryptoJS.AES.decrypt(text, parsedKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decryptedData.toString(CryptoJS.enc.Utf8);
  };

  static encryptAes = (text: string) => {
    const txtFin = typeof text === 'number' ? String(text) : text;
    const parsedKey = CryptoJS.enc.Base64.parse('c2RhOGVmNTRwc3JnaHR5MA==');
    const encryptedData = CryptoJS.AES.encrypt(txtFin, parsedKey, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    });
    return encryptedData.toString();
  };
}
